/**
 * Copyright © Veeam Software Group GmbH.
 */

import { VbrBackupAgentJobKind } from '@veeam-vspc/models/web-controllers';

export type JobKinds = VbrBackupAgentJobKind;
export const JobKinds = VbrBackupAgentJobKind;
